export class VehicleDetails {
  public mmCode: string = null;
  public yearOfManufacture: string = null;
  public registrationNumber: string = null;
  public engineNumber: string = null;
  public licenseExpiryDate: string = null;
  public vinNumber: string = null;
  public maskedVinNumber: string = null;
  public makeDescr: string = null;
  public modelDescr: string = null;
  public colorDescr: string = 'Select Colour';
  public colorCd: string = 'Select Colour';
  public modelRangeDescr: string = null;
  public modelRangeYear: string = null;
  public usage: string = null;
  public parkingSecurity: string = null;
  public modelRangeYearCode: string = null;
  public description: string = null;
  constructor() {
  }
}
